import AdvocateKathyayanDetails from '../../components/about/advocates-details/kathyayan';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateKathyayanDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | N. Kathyayan Reddy'>
      <NavigationMenu active='about' />
      <PageHeader
        title='N. Kathyayan Reddy'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateKathyayanDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateKathyayanDetailsPage;

